// extracted by mini-css-extract-plugin
export default {"buttonUpload":"styles_buttonUpload__elHbL"};